export default class IntersectionObserverFix {
  constructor(triggerSelector, targetSelector, activeClass) {
    this.triggerBase = document.querySelector(triggerSelector);
    this.target = document.querySelector(targetSelector);
    this.activeClass = activeClass;
    this.trigger = null;
    this.observer = null;

    if (!this.triggerBase || !this.target) return;

    this._init();
  }

  _init() {
    this._createTrigger();
    this._intersectionObserver();
    this._bindEvents();
  }

  _createTrigger() {
    if (this.trigger) {
      this.trigger.remove();
    }

    const triggerTop = Math.max(
      window.innerHeight - this.triggerBase.offsetHeight,
      0,
    );

    this.trigger = document.createElement("div");
    this.trigger.setAttribute("aria-hidden", "true");
    this.trigger.style.position = "absolute";
    this.trigger.style.top = `${triggerTop}px`;
    this.trigger.style.left = "0";
    this.trigger.style.width = "1px";
    this.trigger.style.height = "1px";
    this.trigger.style.pointerEvents = "none";
    this.trigger.style.opacity = "0";

    document.body.appendChild(this.trigger);
  }

  _intersectionObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }

    const observerOptions = {
      root: null,
      threshold: 0,
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.target.classList.remove(this.activeClass);
        } else {
          this.target.classList.add(this.activeClass);
        }
      });
    };

    this.observer = new IntersectionObserver(
      handleIntersection,
      observerOptions,
    );

    this.observer.observe(this.trigger);
  }

  _bindEvents() {
    window.addEventListener("resize", () => {
      this._createTrigger();
      this._intersectionObserver();
    });
  }
}
